import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../../styles/colors';

export const clioColor = '#1370E0';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		boxShadow: 'none',
		color: brandPrimary,
		marginTop: 20,
	},
	integrationTitle: {
		color: clioColor,
	},
	logo: {
		height: 24,
		width: 24,
	},
});
